import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useCommonStyles } from "../../utils";

const CommonRadioButton = ({
  label,
  radioLabels,
  name,
  selectedValue,
  handleChange,
  mt,
  disabled,
  color,
  borderRadius,
  backgroundColor,
  marginLeft,
  pr,
  marginTop,
  marginBottom,
  fontWeight,
  fontSize,
  fontFamily,
  labelColor,
  valid
}) => {
  const { classes } = useCommonStyles();

  return (
    <>
      <FormControl sx={{ mt: mt ? mt : 0 }}>
        {label &&
          <Box display={"flex"} gap={'2px'}>
            <FormLabel
              id="radio-buttons-group-label"
              className={classes.label}
              sx={{
                fontWeight: fontWeight ? fontWeight : "500",
                fontSize: fontSize ? fontSize : "14px",
                fontFamily: "Satoshi-Medium",
                color: labelColor || "#2E2E30",
                marginBottom: marginBottom || "8px",
                textTransform: "capitalize",
              }}
            >
              {label}
            </FormLabel>
            {valid && (
              <Typography height={'5px'} color="#EF627A" component={"caption"} variant={"body2"}>
                *
              </Typography>
            )}
          </Box>
        }
        <RadioGroup
          row
          aria-labelledby="radio-buttons-group-label"
          name={name}
          value={selectedValue}
          onChange={handleChange}
          sx={{ gap: "5px", ml: marginLeft }}
        >
          {radioLabels.map((radioLabel, index) => (
            <FormControlLabel
              key={index}
              value={radioLabel.value}
              control={
                <Radio
                // sx={{
                //     '&.Mui-checked': {
                //         color: 'red !important',
                //     },
                // }}
                />
              }
              label={radioLabel.label}
              className={classes.radioButton}
              disabled={disabled}
              sx={{
                color: color ? color : "#8F8F8F",
                borderRadius: borderRadius ? borderRadius : "0px",
                backgroundColor: backgroundColor
                  ? backgroundColor
                  : "transparent",
                pr: pr ? pr : 2,
                marginTop: marginTop ? marginTop : "-18px",
                "& .MuiFormControlLabel-label": {
                  fontFamily: "Satoshi-Medium"
                },
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default CommonRadioButton;
